import React, { useState } from "react";
import DeliveryBandUnDeclared from "./DeliverBandUnDeclared";
import AllDeliveryBand from "./AllDeliveryBand";
import TabButton from "./TabButton";
import DeliveryBandDeclared from "./DeliveryBandDeclared";

const DeliveryBand = () => {
  const [activeTab, setActiveTab] = useState("tab1");

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  const tabData = [
    {
      tab: "tab1",
      label: "Bons de livraison",
      component: <AllDeliveryBand />,
    },
    {
      tab: "tab2",
      label: "Bons de livraison declaré",
      component: <DeliveryBandDeclared />,
    },
    {
      tab: "tab3",
      label: "Bons de livraison non declaré",
      component: <DeliveryBandUnDeclared />,
    },
  ];

  return (
    <div className="tabs-container">
      <div className="tabs-header" style={{ marginBottom: "10px" }}>
        {tabData.map(({ tab, label }) => (
          <TabButton
            key={tab}
            tab={tab}
            label={label}
            activeTab={activeTab}
            handleTabClick={handleTabClick}
          />
        ))}
      </div>

      <div className="tabs-content">
        {tabData.find(({ tab }) => tab === activeTab)?.component}
      </div>
    </div>
  );
};

export default DeliveryBand;
